import "./cart-content";

class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.requestId = 1;
    this.closeButton = this.querySelector("[data-close]");
    this.content = this.querySelector(".mini-cart__content");

    this.closeButton?.addEventListener("click", () => this._close());
    this.addEventListener("click", (e) => {
      if (e.target.closest(".mini-cart__content")) return;

      this._close();
    });

    this.handleDocumentClick = (e) => {
      // Ignore clicks on items no longer in DOM
      if (!document.body.contains(e.target)) return;

      if (!this.content.contains(e.target)) {
        this._close();
      }
    };

    document.addEventListener("click", this.handleDocumentClick);

    this.closeEsc = (e) => {
      if (e.key === "Escape") {
        this._close();
      }
    };

    document.addEventListener("keydown", this.closeEsc);

    document.addEventListener("mini-cart:open", (event) =>
      this._open(event.detail?.autoOpened === true),
    );
    document.addEventListener("mini-cart:close", () => this._close());

    if (new URL(window.location).searchParams.has("cart")) {
      this._open(true);
    }
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
    document.removeEventListener("click", this.handleDocumentClick);
  }

  _toggle() {
    this.hasAttribute("open") ? this._close() : this._open();
  }

  _open(autoOpened = false) {
    if (this.hasAttribute("open")) return;

    this.autoOpened = autoOpened;
    document.dispatchEvent(new CustomEvent("markup-modal:close"));

    this.style.display = "block";
    window.requestAnimationFrame(() => {
      this.setAttribute("open", "");
      window.openFullDimmer(this);
      window.lockScroll(this);
      this.returnFocusEl = document.activeElement;
      this._focusIn();
    });
  }

  _focusIn() {
    const closeButton = this.querySelector("[data-close]");
    const dialog = this.querySelector('[role="dialog"]');

    window.trapFocus(this, closeButton || dialog || this);
  }

  _returnFocus() {
    const stored = this.returnFocusEl;

    if (
      stored &&
      stored !== document.body &&
      document.body.contains(stored) &&
      typeof stored.focus === "function"
    ) {
      window.removeTrapFocus(stored);
      return;
    }

    const trigger = document.querySelector(".header__cart-icon");

    if (!this.autoOpened && trigger) {
      window.removeTrapFocus(trigger);
      return;
    }

    window.removeTrapFocus();
    document.body.setAttribute("tabindex", "-1");
    document.body.focus();
    document.body.removeAttribute("tabindex");
  }

  _close() {
    if (!this.hasAttribute("open")) return;

    this.removeAttribute("open");
    window.closeFullDimmer(this);
    this._returnFocus();

    const onEnd = () => {
      this.removeEventListener("transitionend", onEnd);

      if (this.hasAttribute("open")) return;
      this.style.display = null;
      window.unlockScroll(this);
    };
    this.addEventListener("transitionend", onEnd);
  }
}

if (!customElements.get("mini-cart")) {
  customElements.define("mini-cart", MiniCart);
}
